"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEventsFromProcessData = void 0;
const Logger_1 = require("../../../../Logger");
const index_1 = require("../../../../Errors/index");
const index_2 = require("../../../Model/index");
const TypeFactory_1 = require("../../TypeFactory");
const ExtensionPropertyParser_1 = require("./ActivityParsers/ExtensionPropertyParser");
const logger = new Logger_1.Logger('engine:process_model_parser:event_parser');
let errors = [];
let eventDefinitions = [];
var TimerEventDefinitionBpmnTag;
(function (TimerEventDefinitionBpmnTag) {
    TimerEventDefinitionBpmnTag["Duration"] = "bpmn:timeDuration";
    TimerEventDefinitionBpmnTag["Cycle"] = "bpmn:timeCycle";
    TimerEventDefinitionBpmnTag["Date"] = "bpmn:timeDate";
})(TimerEventDefinitionBpmnTag || (TimerEventDefinitionBpmnTag = {}));
function parseEventsFromProcessData(processData, parsedErrors, parsedEventDefinitions) {
    errors = parsedErrors;
    eventDefinitions = parsedEventDefinitions;
    const startEvents = parseEventsByType(processData, index_2.BpmnTags.EventElement.StartEvent, index_2.Model.Events.StartEvent);
    const endEvents = parseEventsByType(processData, index_2.BpmnTags.EventElement.EndEvent, index_2.Model.Events.EndEvent);
    const intermediateThrowEvents = parseEventsByType(processData, index_2.BpmnTags.EventElement.IntermediateThrowEvent, index_2.Model.Events.IntermediateThrowEvent);
    const intermediateCatchEvents = parseEventsByType(processData, index_2.BpmnTags.EventElement.IntermediateCatchEvent, index_2.Model.Events.IntermediateCatchEvent);
    const boundaryEvents = parseBoundaryEvents(processData);
    return Array.prototype.concat(startEvents, endEvents, intermediateThrowEvents, intermediateCatchEvents, boundaryEvents);
}
exports.parseEventsFromProcessData = parseEventsFromProcessData;
function parseEventsByType(data, eventTypeTag, targetType) {
    var _a, _b;
    const events = [];
    const eventsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, eventTypeTag);
    const noEventsFound = !((eventsRaw === null || eventsRaw === void 0 ? void 0 : eventsRaw.length) > 0);
    if (noEventsFound) {
        return [];
    }
    for (const eventRaw of eventsRaw) {
        const flowNodeId = eventRaw.id;
        try {
            const event = (0, TypeFactory_1.createObjectWithCommonProperties)(eventRaw, targetType);
            event.name = eventRaw.name;
            event.defaultOutgoingSequenceFlowId = eventRaw.default;
            event.incoming = (0, TypeFactory_1.getModelPropertyAsArray)(eventRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowIncoming);
            event.outgoing = (0, TypeFactory_1.getModelPropertyAsArray)(eventRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowOutgoing);
            event.preScript = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPreScript', event.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
            event.postScript = (_b = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPostScript', event.extensionElements.camundaExtensionProperties)) === null || _b === void 0 ? void 0 : _b.value;
            assignDataInputAssociations(event, eventRaw);
            assignDataOutputAssociations(event, eventRaw);
            assignEventDefinition(event, eventRaw);
            setInputValues(event);
            setCustomCorrelationId(event);
            events.push(event);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    }
    return events;
}
function parseBoundaryEvents(processData) {
    var _a, _b, _c;
    const events = [];
    const boundaryEventsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_2.BpmnTags.EventElement.Boundary);
    const noBoundaryEventsFound = !((boundaryEventsRaw === null || boundaryEventsRaw === void 0 ? void 0 : boundaryEventsRaw.length) > 0);
    if (noBoundaryEventsFound) {
        return [];
    }
    for (const boundaryEventRaw of boundaryEventsRaw) {
        const flowNodeId = boundaryEventRaw.id;
        try {
            const boundaryEvent = (0, TypeFactory_1.createObjectWithCommonProperties)(boundaryEventRaw, index_2.Model.Events.BoundaryEvent);
            boundaryEvent.incoming = (0, TypeFactory_1.getModelPropertyAsArray)(boundaryEventRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowIncoming);
            boundaryEvent.outgoing = (0, TypeFactory_1.getModelPropertyAsArray)(boundaryEventRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowOutgoing);
            boundaryEvent.preScript = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPreScript', boundaryEvent.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
            boundaryEvent.postScript = (_b = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPostScript', boundaryEvent.extensionElements.camundaExtensionProperties)) === null || _b === void 0 ? void 0 : _b.value;
            assignDataOutputAssociations(boundaryEvent, boundaryEventRaw);
            boundaryEvent.name = boundaryEventRaw.name;
            boundaryEvent.defaultOutgoingSequenceFlowId = boundaryEventRaw.default;
            boundaryEvent.attachedToRef = boundaryEventRaw.attachedToRef;
            // NOTE: Interrupting BoundaryEvents are sometimes missing this property!
            // However, non-interrupting BoundaryEvents always have it.
            const cancelActivity = boundaryEventRaw.cancelActivity === undefined ||
                boundaryEventRaw.cancelActivity === 'true' ||
                boundaryEventRaw.cancelActivity === true;
            boundaryEvent.cancelActivity = cancelActivity;
            assignEventDefinition(boundaryEvent, boundaryEventRaw);
            const isCyclicTimerBoundaryEvent = ((_c = boundaryEvent.timerEventDefinition) === null || _c === void 0 ? void 0 : _c.timerType) === index_2.Model.Events.Definitions.TimerType.timeCycle;
            if (isCyclicTimerBoundaryEvent) {
                createAndThrowValidationError(boundaryEvent, boundaryEventRaw, 'Using cyclic timers for BoundaryEvents is not allowed!');
            }
            events.push(boundaryEvent);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    }
    return events;
}
function assignDataInputAssociations(instance, rawData) {
    var _a;
    const dataInputAssociationsRaw = (_a = (0, TypeFactory_1.getModelPropertyAsArray)(rawData, index_2.BpmnTags.FlowElementProperty.DataInputAssociation)) !== null && _a !== void 0 ? _a : [];
    instance.dataInputAssociations = dataInputAssociationsRaw.map((entry) => {
        const mappedDataInputAssociation = (0, TypeFactory_1.createObjectWithCommonProperties)(entry, index_2.Model.Base.DataInputAssociation);
        mappedDataInputAssociation.sourceRef = entry[index_2.BpmnTags.CommonElement.BpmnSourceRef];
        mappedDataInputAssociation.targetRef = entry[index_2.BpmnTags.CommonElement.BpmnTargetRef];
        return mappedDataInputAssociation;
    });
}
function assignDataOutputAssociations(instance, rawData) {
    var _a;
    const dataOutputAssociationsRaw = (_a = (0, TypeFactory_1.getModelPropertyAsArray)(rawData, index_2.BpmnTags.FlowElementProperty.DataOutputAssociation)) !== null && _a !== void 0 ? _a : [];
    instance.dataOutputAssociations = dataOutputAssociationsRaw.map((entry) => {
        var _a, _b, _c;
        const mappedDataInputAssociation = (0, TypeFactory_1.createObjectWithCommonProperties)(entry, index_2.Model.Base.DataOutputAssociation);
        mappedDataInputAssociation.sourceRef = entry[index_2.BpmnTags.CommonElement.BpmnSourceRef];
        mappedDataInputAssociation.targetRef = entry[index_2.BpmnTags.CommonElement.BpmnTargetRef];
        // For compatibility with diagrams that were created with the .NET engine.
        mappedDataInputAssociation.dataSource =
            (_b = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('dataSource', mappedDataInputAssociation.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (_c = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('DataSource', mappedDataInputAssociation.extensionElements.camundaExtensionProperties)) === null || _c === void 0 ? void 0 : _c.value;
        return mappedDataInputAssociation;
    });
}
function assignEventDefinition(event, eventRaw) {
    const eventHasErrorEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.ErrorEventDefinition] !== undefined;
    const eventHasLinkEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.LinkEventDefinition] !== undefined;
    const eventHasMessageEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.MessageEventDefinition] !== undefined;
    const eventHasSignalEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.SignalEventDefinition] !== undefined;
    const eventHasTimerEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.TimerEventDefinition] !== undefined;
    const eventHasTerminateEvent = eventRaw[index_2.BpmnTags.FlowElementProperty.TerminateEventDefinition] !== undefined;
    // Might look a little weird, but counting "true" values is actually a lot easier than trying out every possible combo.
    // It doesn't matter which events are modelled anyway, as soon as there is more than one, the FlowNode is simply not usable.
    const allResults = [eventHasErrorEvent, eventHasLinkEvent, eventHasMessageEvent, eventHasSignalEvent, eventHasTimerEvent, eventHasTerminateEvent];
    const eventHasTooManyDefinitions = allResults.filter((entry) => entry === true).length > 1;
    if (eventHasTooManyDefinitions) {
        createAndThrowValidationError(event, eventRaw, `Event '${event}' has more than one type of event definition! This is not permitted!`);
    }
    if (eventHasErrorEvent) {
        assignErrorEventDefinition(event, eventRaw);
    }
    else if (eventHasMessageEvent) {
        assignMessageEventDefinition(event, eventRaw);
    }
    else if (eventHasSignalEvent) {
        assignSignalEventDefinition(event, eventRaw);
    }
    else if (eventHasTimerEvent) {
        assignTimerEventDefinition(event, eventRaw);
    }
    else if (eventHasTerminateEvent) {
        event.terminateEventDefinition = {};
    }
    else if (eventHasLinkEvent) {
        assignLinkEventDefinition(event, eventRaw);
    }
}
function assignErrorEventDefinition(event, eventRaw) {
    const errorId = eventRaw[index_2.BpmnTags.FlowElementProperty.ErrorEventDefinition].errorRef;
    const defaultError = {
        id: '',
        code: '',
        name: '',
        message: '',
    };
    const errorObject = errorId
        ? errors.find((entry) => entry.id === errorId)
        : defaultError;
    if (!errorObject) {
        createAndThrowValidationError(event, eventRaw, `Error reference on event ${event.id} is invalid!`);
    }
    const eventErrorMessage = eventRaw[index_2.BpmnTags.FlowElementProperty.ErrorEventDefinition][index_2.BpmnTags.CamundaProperty.ErrorMessageVariable];
    if (!errorObject.message) {
        errorObject.message = eventErrorMessage;
    }
    event.errorEventDefinition = errorObject;
}
function assignLinkEventDefinition(event, eventRaw) {
    const eventDefinitonRaw = eventRaw[index_2.BpmnTags.FlowElementProperty.LinkEventDefinition];
    if (!(eventDefinitonRaw === null || eventDefinitonRaw === void 0 ? void 0 : eventDefinitonRaw.name)) {
        // TODO: Usually, this should throw an error. However, doing so would break the "GetAllProcessModels" queries,
        // which would in turn break BPMN Studio and thus leaving the user without any way to fix the diagram.
        // Maybe we should think about introducting some kind of leniency setting for the parser, to be able to only throw errors in certain UseCases.
        logger.warn(`LinkEvent with ID ${event.id} is missing a link name! The event will not be executable!`, { event: event });
    }
    event.linkEventDefinition = new index_2.Model.Events.Definitions.LinkEventDefinition(eventDefinitonRaw.name);
}
function assignMessageEventDefinition(event, eventRaw) {
    const eventDefinitonRaw = eventRaw[index_2.BpmnTags.FlowElementProperty.MessageEventDefinition];
    const messageDefinition = getDefinitionForEvent(eventDefinitonRaw === null || eventDefinitonRaw === void 0 ? void 0 : eventDefinitonRaw.messageRef);
    if (!messageDefinition) {
        // same as above
        logger.warn(`Message reference '${eventDefinitonRaw === null || eventDefinitonRaw === void 0 ? void 0 : eventDefinitonRaw.messageRef}' on MessageEvent ${event.id} is invalid! The event will not be executable!`, { event: event });
    }
    event.messageEventDefinition = messageDefinition;
}
function assignSignalEventDefinition(event, eventRaw) {
    const eventDefinitonRaw = eventRaw[index_2.BpmnTags.FlowElementProperty.SignalEventDefinition];
    const signalDefinition = getDefinitionForEvent(eventDefinitonRaw === null || eventDefinitonRaw === void 0 ? void 0 : eventDefinitonRaw.signalRef);
    if (!signalDefinition) {
        // Same as above.
        logger.warn(`Signal reference '${eventDefinitonRaw === null || eventDefinitonRaw === void 0 ? void 0 : eventDefinitonRaw.signalRef}' on SignalEvent ${event.id} is invalid! The event will not be executable!`, { event: event });
    }
    event.signalEventDefinition = signalDefinition;
}
function assignTimerEventDefinition(event, eventRaw) {
    var _a;
    const eventDefinitonValue = eventRaw[index_2.BpmnTags.FlowElementProperty.TimerEventDefinition];
    const isEnabledCamundaProperty = ((_a = event === null || event === void 0 ? void 0 : event.extensionElements) === null || _a === void 0 ? void 0 : _a.camundaExtensionProperties)
        ? (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('enabled', event.extensionElements.camundaExtensionProperties)
        : undefined;
    const isEnabled = isEnabledCamundaProperty !== undefined
        ? isEnabledCamundaProperty.value === 'true'
        : true;
    const timerType = parseTimerDefinitionType(eventDefinitonValue);
    const timerValue = parseTimerDefinitionValue(eventDefinitonValue);
    if (timerType == undefined || !((timerValue === null || timerValue === void 0 ? void 0 : timerValue.length) > 0)) {
        // Same as above.
        logger.warn(`Timer reference on TimerEvent ${event.id} is invalid! The event will not be executable!`, { event: event });
    }
    const timerDefinition = new index_2.Model.Events.Definitions.TimerEventDefinition();
    timerDefinition.enabled = isEnabled;
    timerDefinition.timerType = timerType;
    timerDefinition.value = timerValue;
    event.timerEventDefinition = timerDefinition;
}
function parseTimerDefinitionType(eventDefinition) {
    const timerIsCyclic = eventDefinition[TimerEventDefinitionBpmnTag.Cycle] !== undefined;
    if (timerIsCyclic) {
        return index_2.Model.Events.Definitions.TimerType.timeCycle;
    }
    const timerIsDate = eventDefinition[TimerEventDefinitionBpmnTag.Date] !== undefined;
    if (timerIsDate) {
        return index_2.Model.Events.Definitions.TimerType.timeDate;
    }
    const timerIsDuration = eventDefinition[TimerEventDefinitionBpmnTag.Duration] !== undefined;
    if (timerIsDuration) {
        return index_2.Model.Events.Definitions.TimerType.timeDuration;
    }
    return undefined;
}
function parseTimerDefinitionValue(eventDefinition) {
    const timerIsCyclic = eventDefinition[TimerEventDefinitionBpmnTag.Cycle] !== undefined;
    if (timerIsCyclic) {
        return eventDefinition[TimerEventDefinitionBpmnTag.Cycle]._;
    }
    const timerIsDate = eventDefinition[TimerEventDefinitionBpmnTag.Date] !== undefined;
    if (timerIsDate) {
        return eventDefinition[TimerEventDefinitionBpmnTag.Date]._;
    }
    const timerIsDuration = eventDefinition[TimerEventDefinitionBpmnTag.Duration] !== undefined;
    if (timerIsDuration) {
        return eventDefinition[TimerEventDefinitionBpmnTag.Duration]._;
    }
    return undefined;
}
function getDefinitionForEvent(eventDefinitionId) {
    return eventDefinitions.find((entry) => entry.id === eventDefinitionId);
}
function setInputValues(event) {
    var _a;
    event.inputValues = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('inputValues', event.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function setCustomCorrelationId(event) {
    var _a;
    event.customCorrelationId = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.customCorrelationId', event.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function createAndThrowValidationError(event, eventRaw, message) {
    const error = new index_1.UnprocessableEntityError(message);
    error.additionalInformation = {
        eventObject: event,
        rawEventData: eventRaw,
    };
    logger.error(message, { err: error });
    throw error;
}
//# sourceMappingURL=EventParser.js.map